/**
 * YarnBallLoader.jsx
 * Usage: <YarnBallLoader size={72} speed={1.2} label="Loading pattern..." />
 */
import React from "react";
import "./yarn-loader.css";

export default function YarnBallLoader({
  size = 72,
  speed = 1.2,
  label = "Loading...",
}) {
  const style = {
    width: size,
    height: size,
    animationDuration: `${speed}s`,
  };
  return (
    <div
      className="lp-loader"
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="lp-ball" style={style}>
        <svg viewBox="0 0 100 100" className="lp-ball-svg" aria-hidden="true">
          <defs>
            <clipPath id="clip">
              <circle cx="50" cy="50" r="42" />
            </clipPath>
          </defs>
          <circle cx="50" cy="50" r="50" fill="#E7E1DA" />
          <circle cx="50" cy="50" r="42" fill="#C46A4E" />
          <g
            clipPath="url(#clip)"
            stroke="#A54A2E"
            strokeWidth="4"
            fill="none"
            strokeLinecap="round"
          >
            <path d="M5,40 C30,20 70,20 95,40" />
            <path d="M5,55 C30,35 70,35 95,55" />
            <path d="M5,70 C30,50 70,50 95,70" />
            <path d="M20,15 C45,35 55,75 80,90" />
            <path d="M30,12 C55,30 65,70 90,88" />
          </g>
        </svg>
        <span className="lp-tail" />
      </div>
      <div className="lp-label">{label}</div>
    </div>
  );
}
